import { Box, LinearProgress } from "@mui/material";
import React from "react";

export default function LinearLoader() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        margin: "auto",
      }}
    >
      <LinearProgress sx={{ height: "5px", borderRadius: "3px" }} />
    </Box>
  );
}
